import styled from 'styled-components';
import { neutralWhite } from '../themes/colors';

export const UpgradePageContainer = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 64px;
  max-width: 1280px;
  margin: 0 auto;
`;

export const UpgradePageRoot = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${neutralWhite};
`;
